import { useEffect } from "react";

const YANDE_METRIKA_ID = 109083162;

const YandexMetrica = () => {
  useEffect(() => {
    // Define the global function so CookieBanner.onAccept can call it
    window.loadYandexMetrica = () => {
      if (window.ym && typeof window.ym === "function") {
        // Already loaded — no need to inject again
        return;
      }

      // Inline the Yandex.Metrika counter script
      (function (m, e, t, r, i, k, a) {
        m[i] =
          m[i] ||
          function () {
            (m[i].a = m[i].a || []).push(arguments);
          };
        m[i].l = 1 * new Date();
        for (var j = 0; j < document.scripts.length; j++) {
          if (document.scripts[j].src === r) {
            return;
          }
        }
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode.insertBefore(k, a);
      })(
        window,
        document,
        "script",
        "https://mc.yandex.ru/metrika/tag.js?id=" + YANDE_METRIKA_ID,
        "ym"
      );

      window.ym(YANDE_METRIKA_ID, "init", {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: "dataLayer",
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true,
      });
    };

    // If consent was already given in a previous visit, load immediately
    const consent = localStorage.getItem("cookie-consent");
    if (consent === "accepted") {
      window.loadYandexMetrica();
    }

    // Cleanup: remove the global function when component unmounts
    return () => {
      delete window.loadYandexMetrica;
    };
  }, []);

  return null;
};

export default YandexMetrica;
